import React from 'react';
import './Loading.css';

function Loading({ message = 'Loading...', title = 'EaseVerse', onBack, showToolbar = true }) {
  const handleBack = onBack || (() => { window.location.href = '/'; });
  const isEink = document.documentElement.getAttribute('data-eink') === 'true';

  return (
    <div className="loading-screen">
      {showToolbar && (
        <header className="loading-toolbar">
          <button className="loading-back-btn" onClick={handleBack} title="Back to Library">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="loading-title">{title}</h1>
        </header>
      )}
      <div className="loading-container">
        <div className="loading-content">
          <div className="loading-book">
            <svg viewBox="0 0 64 40" className="loading-book-svg" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 6v28c0 0 10-6 28-6s28 6 28 6V6c0 0-10 6-28 6S4 6 4 6z" />
              <path d="M32 6v28" opacity="0.4" />
            </svg>
            {isEink ? <div className="loading-static-indicator" /> : <div className="loading-shimmer" />}
          </div>
          <p className="loading-message">{message}</p>
        </div>
      </div>
    </div>
  );
}

export default Loading;

